import axios from "axios";
export const getAllListIndustryTypes = {
  data() {
    return {
      getAllIndustryTypes: [],
      overlay: false,
    };
  },
  methods: {
    async getAllListIndustryTypesMethod() {
      this.overlay = true;
      const apiUrl =
        process.env.VUE_APP_AWS_LIST_INDUSTRY_TYPES_REST_API_END_POINT;
      //  const apiKey = process.env.VUE_APP_AWS_CREATE_USER_ACCOUNT_REST_API_KEY;
      try {
        const result = await axios.post(apiUrl, {
          headers: {
            "Content-Type": "application/json",
            //   "x-api-key": apiKey,
          },
        });
        //console.log("result of getAllListIndustryTypesMethod", result);
        if (result.data.status === "SUCCESS") {
          this.getAllIndustryTypes = result.data.data.items;
          //console.log("getAllIndustryTypes", this.getAllIndustryTypes);
        }
      } catch (error) {
        //console.error("Error in getAllListIndustryTypesMethod:", error);
        return "ERROR";
      } finally {
        this.overlay = false;
      }
    },
  },
};
